export default "__VITE_ASSET__DveJv$ai__"